module.exports = __webpack_public_path__ + "static/Gotham-MediumItalic-09dcc6f06831216548bce70796e09150.woff2";